module.exports = __webpack_public_path__ + "img/aptable.d5cf9c0e.png";